import { render, staticRenderFns } from "./ChatBanKeywordPage.vue?vue&type=template&id=a267d80a&scoped=true"
import script from "./ChatBanKeywordPage.vue?vue&type=script&lang=js"
export * from "./ChatBanKeywordPage.vue?vue&type=script&lang=js"
import style0 from "./ChatBanKeywordPage.vue?vue&type=style&index=0&id=a267d80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a267d80a",
  null
  
)

export default component.exports